import { gql } from '@apollo/client';

import { REPORT_COMMON_FIELDS } from '../fragments/reportCommonFields';
import { STANDARD_DELIVERY_REPORT_FILTERS } from '../fragments/standardDeliveryReportFilters';

export const UPDATE_STANDARD_DELIVERY_REPORT = gql`
    mutation updateStandardDeliveryReport($id: ID!, $report: UpdateReportInput!, $filters: StandardDeliveryReportFiltersInput!) {
      updateStandardDeliveryReport(id: $id, report: $report, filters: $filters) {
        ...reportCommonFields
        filters {
          ...standardDeliveryReportFilters
        }
      }
    }
    ${REPORT_COMMON_FIELDS},
    ${STANDARD_DELIVERY_REPORT_FILTERS}
`;
